import { formatadores } from 'utils/validators';

export const handleProfissaoCodePayload = (
  isBanking,
  isEproposal,
  formProfessional
) => {
  return isBanking
    ? isEproposal
      ? Number(formProfessional?.profissao_code)
      : Number(formProfessional?.profissao)
    : 0;
};

export const handleOcupacaoCodePayload = (
  isBanking,
  isEproposal,
  formProfessional
) => {
  return isBanking
    ? isEproposal
      ? Number(formProfessional?.ocupacao_code)
      : Number(formProfessional?.ocupacao)
    : 0;
};

export const handleCarencia = (data_aprovado, data_primeira_parcela) => {
  const formatedAprovado = formatadores.TIMESTAMP_TO_BR(data_aprovado);
  const formatedPrimeiraParcela = formatadores.ISO_TO_BR(data_primeira_parcela);

  const convertDateToDays = (startDate, endDate) => {
    const [startDay, startMonth, startYear] = startDate.split('/').map(Number);

    const [endDay, endMonth, endYear] = endDate.split('/').map(Number);

    const startUtcDate = Date.UTC(startYear, startMonth - 1, startDay);

    const endUtcDate = Date.UTC(endYear, endMonth - 1, endDay);

    const differenceInMilliseconds = endUtcDate - startUtcDate;

    return Math.floor(differenceInMilliseconds / (1000 * 60 * 60 * 24));
  };

  return convertDateToDays(formatedAprovado, formatedPrimeiraParcela);
};

export const handleAcceptedBanking = (registro) => {
  const bankAccepted = registro.bancos?.find((bank) => bank.aceito === true);

  bankAccepted['carencia'] = handleCarencia(
    registro.data_aprovado,
    bankAccepted?.data
  );

  return bankAccepted;
};
